import React, { useEffect, useState } from 'react';
import Skeleton from 'components/Skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { pendingUserRequest, verifiedUserRequest } from './verifiedUsersSlice';
import CustomTable from 'components/CustomTable';
import { Grid } from '@material-ui/core';
import { showLoader } from 'utils';



const VerifiedUser = () => {
  const dispatch = useDispatch();

  const loading = useSelector(state => state.verifiedUser.loading);
  const totalVerifiedUsers = useSelector(state => state.verifiedUser.totalList);
  const verifiedUserList = useSelector(
    state => state.verifiedUser.verifiedUser
  );

  const [allVerifiedUser, setAllVerifiedUser] = useState([]);

  console.log(loading, 'loading');


  useEffect(() => {
    setAllVerifiedUser(Object.values(verifiedUserList));
  }, [verifiedUserList]);


  const getVerifiedUsers = (start, keyword, fromDate, toDate, sortBy, sortType) => {
    const obj = {
      keyword: keyword || '',
      fromDate: fromDate || '',
      toDate: toDate || '',
      sortBy: sortBy || '',
      sortType: sortType || '',
      type: 'verified',
    };
    dispatch(
      verifiedUserRequest({
        data: obj,
        start: start || 0,
        limit: 10,
      })
    );
  };


  const movePendingUser = (start, id, type, val) => {
    console.log(id, 'movePendingUser');
    dispatch(pendingUserRequest({
      data: {
        status: type,
        fromPending: val,
        userIds: [id],
      }
    }));
    setTimeout(() => {
      getVerifiedUsers(start);
    }, 999);
  };

  return (
    <Skeleton>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CustomTable
            tableBodyData={allVerifiedUser}
            getAllUsers={getVerifiedUsers}
            movePendingUser={movePendingUser}
            type='verify'
            totalUser={totalVerifiedUsers}
          />
        </Grid>
      </Grid>
      {showLoader(loading, 'transparent')}
    </Skeleton>
  );
};

export default VerifiedUser;
